"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconFileAdd = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M11.6666667,1.66666667 L5,1.66666667 C4.08333333,1.66666667 3.34166667,2.41666667 3.34166667,3.33333333 L3.33333333,16.6666667 C3.33333333,17.5833333 4.075,18.3333333 4.99166667,18.3333333 L15,18.3333333 C15.9166667,18.3333333 16.6666667,17.5833333 16.6666667,16.6666667 L16.6666667,6.66666667 L11.6666667,1.66666667 Z M13.3333333,13.3333333 L10.8333333,13.3333333 L10.8333333,15.8333333 L9.16666667,15.8333333 L9.16666667,13.3333333 L6.66666667,13.3333333 L6.66666667,11.6666667 L9.16666667,11.6666667 L9.16666667,9.16666667 L10.8333333,9.16666667 L10.8333333,11.6666667 L13.3333333,11.6666667 L13.3333333,13.3333333 Z M10.8333333,7.5 L10.8333333,2.91666667 L15.4166667,7.5 L10.8333333,7.5 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconFileAdd')(IconFileAdd);